import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { STATUS_CANCELED, STATUS_DONE, STATUS_SUMMARY } from '../../../../helpers/constants';
import { MarkerService } from '../../../../services/marker.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-work-order-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './work-order-status-indicator.component.html',
  styleUrl: './work-order-status-indicator.component.css'
})
export class WorkOrderStatusIndicatorComponent {
  @Input() response!: string;

  $servicingAORPhone!: Observable<string>;

  constructor(private markerService: MarkerService) {
    this.$servicingAORPhone = this.markerService.$servicingAORPhone;
  }

  INVALID_WORK_ORDER: string = `Looks like there's a problem locating this Sea Tow Job Ticket, please dial our Call Center at 1-800-4-seatow for assistance.`;
  
  renderProperResponse(response: string, phoneNumber: string): string {
    switch (response) {
      case 'statusCanceled':
        return STATUS_CANCELED(phoneNumber);
      case 'statusDone':
        return STATUS_DONE(phoneNumber);
      case 'statusSummary':
        return STATUS_SUMMARY
      default:
        return this.INVALID_WORK_ORDER;
    }
  }
}
